import { handlePuzzelCallback } from "app/PuzzelAuth/puzzelAuth";
import { TrainLoader } from "app/TrainLoader";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { FC, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const PuzzelCallback: FC = () => {
  const navigate = useNavigate();
  // The auth code is single-use - guards against React StrictMode's dev-only double effect invoke.
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    const completeLogin = async () => {
      try {
        const returnPath = await handlePuzzelCallback();
        void navigate(returnPath, { replace: true });
      } catch (error) {
        log(
          LogLevel.error,
          "PuzzelCallback",
          "Failed to complete Puzzel login",
          error,
        );
        void navigate("/", { replace: true });
      }
    };

    void completeLogin();
  }, [navigate]);

  return <TrainLoader />;
};
